const tailwind = require('../tailwind')

module.exports = {
  pathPrefix: '/kdec', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'KDE Connect- unify your devices!', // Navigation and Site Title
  siteTitleAlt: 'KDE_Connect', // Alternative Site title for SEO
  siteTitleShort: 'KDE Connect', // short_name for manifest
  siteHeadline: 'KDE Connect provides a set of features to integrate your workflow across devices.',
  siteUrl: 'https://brute4s99.gitlab.io', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/log.png', // Used for SEO and manifest
  siteDescription: 'KDE Connect is a project that enables all your devices to communicate with each other.',

  // Manifest and Progress color
  themeColor: tailwind.colors.orange,
  backgroundColor: tailwind.colors.blue,
}
